import { ArrowLeft, GraduationCap } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '~/components/ui/button'

/** Apprenant ou formateur : pas d'inscription libre, on l'oriente vers son organisme. */
function SignupLearner({ onBack }: { onBack: () => void }) {
  const { t } = useTranslation()
  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col items-center gap-4 rounded-2xl border border-border bg-muted/50 px-6 py-8 text-center">
        <span className="flex size-14 items-center justify-center rounded-full bg-accent text-accent-foreground">
          <GraduationCap className="size-7" aria-hidden />
        </span>
        <p className="text-sm text-muted-foreground">{t('signup.learner.description')}</p>
      </div>
      <Button variant="outline" onClick={onBack} className="w-full">
        <ArrowLeft className="mr-2 size-4" aria-hidden />
        {t('signup.back')}
      </Button>
    </div>
  )
}

export default SignupLearner
